// extracted by mini-css-extract-plugin
module.exports = {"text":"pagination_text__NovaA","button":"pagination_button__25adr"};